/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */
import { schema } from 'normalizr';
export var emailTemplate = new schema.Entity('emailTemplates', {});
export var emailConfiguration = new schema.Entity('emailConfigurations', {
  emailTemplates: [emailTemplate]
});